
<style>
    .nav-m {
        transition: 0.3s all ease;
        overflow: hidden;
    }
    .nav-m .navTop{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
    }
    .nav-m .logo-m.navTop{
        opacity: 0;
        display: block;
        visibility: hidden;
        pointer-events: none;
        transition-delay: 0s;
    }
    .nav-m:hover .logo-m.navTop{
        opacity: 1;
        visibility: visible;
        pointer-events: all;
        transition: 0.3s all ease;
        transition-delay: 0.05s;
    }
    .nav-m .time-m.navTop{
        opacity: 1;
        visible: visible;
        transition: 0.3s all ease;
    }
    .nav-m:hover .time-m.navTop{
        display: block;
        opacity: 0;
        visible: hidden;
        transition: none;
        pointer-events: none;
    }
    .portal-side-nav li{
        min-width: 279px;
    }
    .portal-side-nav li a {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
    }
    .portal-side-nav li .icon-m {
        width: 30px;
        height: 30px;
        text-align: center;
        display: block;
        margin-left: 10px;
        transition: 0.3s all ease;
    }
    .portal-side-nav li .icon-m img{
        position: absolute;
        left: 50%;
        width: 30px;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .portal-side-nav li a .icon-m img.active, .portal-side-nav li a.active .icon-m img.non-active{
        opacity: 0;
    }
    .portal-side-nav li a.active .icon-m img.active{
        opacity: 1;
    }
    .nav-m:hover .portal-side-nav li .icon-m {
        margin-left: 0;
    }
    .nav-m .portal-side-nav li .labels {
        display: block;
        white-space: nowrap;
        flex: 1;
        opacity: 0;
        pointer-events: none;
        transition: none;
        transition-delay: 0s;
        visibility: hidden;
        text-align: left;
        transform: translateZ(0);
        padding-left: 0;
    }
    .nav-m:hover .portal-side-nav li .labels {
        opacity: 1;
        pointer-events: all;
        visibility: visible;
        transition: 0.3s all ease;
        transition-delay: 0.05s;
        padding-left: 20px;
        font-size: 14px;
    }
    .nav-m .logout-m{
        padding: 20px 0;
    }
    .logout-m button{
        display: flex;
        align-items: center;
        justify-content: center;
        transition: 0.3s all ease;
        width: 100%;
        margin-left: 50px;
    }
    .nav-m:hover .logout-m button{
        margin-left: 0;
    }
    .logout-m button svg{
        width: 20px;
        transition: 0.3s all ease;
    }
    .logout-m .labels{
        display: block;
        padding: 0;
        pointer-events: none;
        opacity: 0;
        visibility: hidden;
        transition: 0.3s all ease;
        transform: translateZ(0);
    }
    .nav-m:hover .logout-m .labels{
        visibility: visible;
        opacity: 1;
        pointer-events: all;
        transition-delay: 0.05s;
        padding-left: 20px;
    }

</style>


<section class="nav-m" *ngIf="showNav">
  <div class="side-nav-m">
    <div class="logo-m navTop">
      <a href="javascript:;">
        <img [src]="navLogo" alt="logo">
      </a>
    </div>
    <div class="time-m navTop">
      <div class="time">
        <span class="hrs">{{ navDateTime | date:'shortTime' }}</span>
      </div>
      <div class="date">
        <span>{{ navDateTime | customDatePipe:'dayMonth' }}</span>
      </div>
    </div>
    <ng-container *ngIf="activeUser.is_writer">
      <div class="feedback_Half" >
        <span class="rating-text">{{ writerFeedback.positive_rating }}<sub>/5</sub></span>
        <div class="stars">
          <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(writerFeedback.positive_floor) >= 1 , 'active-half': parseFloat(writerFeedback.positive_floor) > 0 && parseFloat(writerFeedback.positive_floor) < 1 }"></i>
          <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(writerFeedback.positive_floor) >= 2 , 'active-half': parseFloat(writerFeedback.positive_floor) > 1 && parseFloat(writerFeedback.positive_floor) < 2 }"></i>
          <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(writerFeedback.positive_floor) >= 3 , 'active-half': parseFloat(writerFeedback.positive_floor) > 2 && parseFloat(writerFeedback.positive_floor) < 3 }"></i>
          <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(writerFeedback.positive_floor) >= 4 , 'active-half': parseFloat(writerFeedback.positive_floor) > 3 && parseFloat(writerFeedback.positive_floor) < 4 }"></i>
          <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(writerFeedback.positive_floor) >= 5 , 'active-half': parseFloat(writerFeedback.positive_floor) > 4 && parseFloat(writerFeedback.positive_floor) < 5 }"></i>
        </div>
      </div>

      <div class="feedback_Nav">
        <div class="rating-info">
          <span class="rating-text">Your rating: {{ writerFeedback.positive_rating }}/5</span>
          <div class="stars">
            <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(writerFeedback.positive_floor) >= 1 , 'active-half': parseFloat(writerFeedback.positive_floor) > 0 && parseFloat(writerFeedback.positive_floor) < 1 }"></i>
            <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(writerFeedback.positive_floor) >= 2 , 'active-half': parseFloat(writerFeedback.positive_floor) > 1 && parseFloat(writerFeedback.positive_floor) < 2 }"></i>
            <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(writerFeedback.positive_floor) >= 3 , 'active-half': parseFloat(writerFeedback.positive_floor) > 2 && parseFloat(writerFeedback.positive_floor) < 3 }"></i>
            <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(writerFeedback.positive_floor) >= 4 , 'active-half': parseFloat(writerFeedback.positive_floor) > 3 && parseFloat(writerFeedback.positive_floor) < 4 }"></i>
            <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(writerFeedback.positive_floor) >= 5 , 'active-half': parseFloat(writerFeedback.positive_floor) > 4 && parseFloat(writerFeedback.positive_floor) < 5 }"></i>
          </div>
        </div>
        <p class="feedback-info">Based on {{ writerFeedback.total }} <a href="javascript:;" (click) = "clientModal()">feedbacks</a> from the clients.</p>
      </div>
    </ng-container>
    <div class="portal-pages-m" [ngClass]="{'portal-pages-sub': activeUser.is_writer}">
      <ul class="portal-side-nav">
        <ng-container *ngFor="let menu of menus">
          <li *ngIf="menu.showInMenu">
            <a href="javascript:;" [routerLink]="menu.route" [ngClass]="{'active': menu.active}" [routerLinkActiveOptions]="{exact: true}">
              <div class="icon-m">
                  <img class="non-active" [src]="'assets/images/sidebar-icons/' + menu.image + '.svg'" alt="">
                  <img class="active"     [src]="'assets/images/sidebar-icons/' + menu.image + '-active.svg'" alt="">
                  <span class="noti-count" *ngIf="menu.notiCount > 0">{{ menu.notiCount }}</span>
              </div>
              <span class="labels">{{ menu.name }}</span>
            </a>
          </li>
        </ng-container>
      </ul>
    </div>

    <div class="logout-m">
      <button [disabled]="loading" (click)="logout()">
            <img src="assets/images/sidebar-icons/logout.svg" alt="" *ngIf="!loading">
            <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>

            <span class="labels">Logout</span>
      </button>
    </div>
  </div>

  <!-- Modal -->
  <div class="clientFeedback-m portal_fedback"  *ngIf="FeedbackModalFlag">
      <!-- Modal -->
      <!-- [id]="'clientFeedback'+indx" -->
    <div class="modal fade"  id="writerFeedback_modal" (click)="preventCloseOnClick()" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Client Feedback</h5>
        </div>
        <div class="modal-content">
          <div class="modal-body">
            <div class="clientFeedback-Sub">
              <p class="title-sub">Total Feedbacks : {{writerFeedback.total}}</p>
              <div class="feedbackRound">
                <div class="rounded-Sub">
                  <div class="roundeFeeback">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 34 34">
                      <circle cx="14" cy="14" r="12.9155" class="progress-bar__background" />
                      <circle cx="14" cy="14" r="12.9155" class="progress-bar__progress js-progress-bar" />
                    </svg>

                    <span>{{FeedbackPercentPositive}}%</span>
                  </div>
                  <div class="feedback-Bar">
                    <span class="feedbackbar-Sub" [ngStyle]="{'width': FeedbackPercentPositive + '%'}"></span>
                  </div>
                  <div class="feedback-text">
                    <p>Postivie:{{writerFeedback.positive}}</p>
                  </div>
                </div>
                <div class="rounded-Sub negFeed">
                  <div class="roundeFeeback">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 34 34">
                      <circle cx="14" cy="14" r="12.9155" class="progress-bar__background" />
                      <circle cx="14" cy="14" r="12.9155" class="progress-bar__progress js-progress-barNeg" />
                    </svg>
                    <span>{{FeedbackPercentNegative}}%</span>
                  </div>
                  <div class="feedback-Bar">
                    <span class="feedbackbar-Sub" [ngStyle]="{'width': FeedbackPercentNegative + '%'}"></span>
                  </div>
                  <div class="feedback-text">
                    <p>Negative:{{writerFeedback.negative}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
